import styled from "styled-components";

export const GridContainer = styled.div`
  display: grid;
  height: 100vh;
  grid-template-rows: 120px 300px 3fr 3fr 150px;
  grid-template-columns: 1fr;
  background: ${(props) => `url(${props.backgroundImage})` || props.background};
  background-size: cover;
  background-position: center;
  overflow: hidden;
`;

export const GridCell = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
`;

export const TopRow = styled(GridCell)`
  grid-row: 1;
  grid-column: 1;
  background: ${(props) => props.theme.topRowBackground};
  backdrop-filter: blur(10px);
`;

export const TopRowLeft = styled.div`
  width: 100%;
  height: 100%;
  grid-row: 2;
  grid-column: 1;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 10px;
  padding: 10px;
  align-items: start;
`;

export const TopRowRight = styled(GridCell)`
  display: none; /* מוסתר בפורטרייט */
`;

export const MiddleLeftColumn = styled(GridCell)`
  grid-row: 3;
  grid-column: 1;
  margin: 5px;
  flex-direction: column;
  align-items: center;
  gap: 10px;
`;

export const MiddleCenterColumn = styled(GridCell)`
  grid-row: 3;
  grid-column: 1;
  align-self: start;
  margin: 10px;
  max-height: 100%;
`;

export const MiddleRightColumn = styled(GridCell)`
  display: none;
`;

// export const ExtraRow = styled(GridCell)`
//   grid-row: 4;
//   grid-column: 1;
//   display: grid;
//   grid-template-columns: 1fr 1fr;
//   gap: 10px;
//   padding: 10px;
//   width: 100%;
//   height: 100%;
//   align-items: stretch;
// `;

export const ExtraRow = styled(GridCell)`
  grid-row: 4;
  grid-column: 1;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 10px;
  padding: 10px;
  width: 100%;
  height: 100%;
  align-items: stretch;
  overflow: hidden;
`;
export const BottomRow = styled(GridCell)`
  grid-row: 5;
  grid-column: 1;
  height: 100%;
`;

export const TimeDateBar = styled.div`
  width: 100%;
  height: 90px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 15px;
  box-sizing: border-box;
  color: ${(props) => props.theme.textColor};
  background: ${(props) => props.theme.timeDateBarBackground};
  font-family: ${(props) => props.theme.fontFamily};
  z-index: 10;
`;

export const StyledH5 = styled.h5`
  color: ${(props) => props.textColor};
  font-family: ${(props) => props.fontFamily || "inherit"};
  font-size: 1.3rem;
  text-align: center;
`;

export const ParentContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  height: 100%;
  padding: 10px;
  box-sizing: border-box;
`;

export const HebrewDateText = styled.div`
  font-size: ${(props) => props.theme.hebrewDateFontSize || "1.3rem"};
  text-align: right;
  color: ${(props) => props.theme.textColor};
`;

export const WeatherCenter = styled.div`
  font-size: ${(props) => props.theme.weatherFontSize || "1rem"};
  font-family: ${(props) => props.fontFamily || "inherit"};
  display: flex;
  color: ${(props) => props.color || props.theme.weatherTextColor};
  justify-content: flex-end;
  gap: 10px;
`;

export const TimeClock = styled.div`
  font-size: ${(props) => props.theme.clockFontSize || "2.5rem"};
  text-align: right;

  .timeDate {
    margin-top: 5px;
    font-size: ${(props) => props.theme.dateFontSize || "1rem"};
    display: flex;
    align-items: center;
    justify-content: flex-end;
    color: ${(props) => props.theme.textColor};
  }
`;

export const StyledTimeClock = styled.div`
  font-size: 2.5rem;
  text-align: right;
  color: ${(props) => props.textColor};
  font-family: ${(props) => props.fontFamily || "inherit"};

  .timeDate {
    font-size: 1rem;
    color: ${(props) => props.textColor};
    display: flex;
    align-items: center;
    justify-content: flex-end;
  }
`;

export const RSSWrapper = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  height: 100%;
`;